<div class="d-flex align-items-center">
    <div class="status-round-icon bg-{{ASSIGN_COLOUR_DICT[value]}} me-1"></div>
    <p [class]="textClass || 'f-small'">{{value}}</p>
</div>
